import moment from 'moment'
import axios from 'axios'

const baseUrl = document.getElementById('base_url').value + 'api/v2/'
const widgetId = document.getElementById('widget_id').value
const widgetNonce = document.getElementById('widget_nonce').value
// var apiTokenKey = 'AiAFDRyvd9d4f495e875a2e075a1a4a6e1b97700'

const http = axios.create({
  baseUrl,
  withCredentials: false,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
})

export async function getResourceInfo (resource) {
  if (resource) {
    let url = baseUrl + 'resource/'
    url += resource
    // url += '?token=' + apiTokenKey
    url += '?widget_nonce=' + widgetNonce

    const response = await http.get(url)
    if (response.data.success) {
      let data

      try {
        data = response.data.data
        return data
      } catch (error) {
        // console.warn(error)
        return false
      }
    }
  } else {
    // console.warn('Insufficient api parameters')
    return false
  }
}

export async function getResourceUser (resource) {
  if (resource) {
    let url = baseUrl + 'resource/'
    url += resource
    // url += '?token=' + apiTokenKey
    url += '?widget_nonce=' + widgetNonce

    const response = await http.get(url)

    if (response.data.success) {
      let data

      try {
        data = response.data.data

        let url = baseUrl + 'profile'
        url += '?manager_id=' + data.manager
        // url += '&token=' + apiTokenKey
        url += '&widget_nonce=' + widgetNonce

        const responseP = await http.get(url)

        if (responseP.data.success) {
          let dataP

          try {
            dataP = responseP.data.data

            dataP.resource_title = data.title

            return dataP
          } catch (error) {
            // console.warn(error)
            return false
          }
        }

        return false
      } catch (error) {
        // console.warn(error)
        return false
      }
    }
  } else {
    // console.warn('Insufficient api parameters')
    return false
  }
}

export async function getBookings (resource, dateFrom, dateTo) {
  if (resource && dateFrom && dateTo) {
    let url = baseUrl + 'booking_list'
    url += '?resource_id=' + resource
    url += '&date_from=' + formatDate(dateFrom)
    url += '&date_to=' + formatDate(dateTo)
    url += '&show_details=true'
    url += '&source=resource-widget'
    url += '&widget_id=' + widgetId
    // url += '&token=' + apiTokenKey
    url += '&widget_nonce=' + widgetNonce

    const response = await http.get(url)

    // if (response.data.success) {
      let data
      let publicBookingData = []
      let showQRCode = false

      try {
        data = response.data.data

        if (response.data.public_booking_data) {
          publicBookingData = response.data.public_booking_data
        }

        if (response.data.show_qr_code) {
          showQRCode = response.data.show_qr_code
        }

        if (!response.data.success) {
          return {
            'events': true,
            'show_qr_code': showQRCode
          }
        }

        let events = []
        // if data is an array
        if (Array.isArray(data)) {
          data.forEach((event) => {
            if (event.resources) {
              event.resources.forEach((eventResource) => {
                if (eventResource.instances) {
                  // loop through eventResource instances object
                  let instances = eventResource.instances
                  for (let key in instances) {
                    let booking = instances[key]
                    events.push({
                      title: publicBookingData.includes('booking_title') ? event.title : '',
                      customer: publicBookingData.includes('customer_name') ? event.customer : '',
                      comments: publicBookingData.includes('public_comment') ? event.comments : '',
                      color: publicBookingData.includes('customer_color') ? event.color : '',
                      startDate: moment(booking.from, 'YYYY-MM-DD HH:mm').toDate(),
                      endDate: moment(booking.to, 'YYYY-MM-DD HH:mm').toDate(),
                      resource: booking.resource
                    })
                  }
                }
              })
            }
          })
          events.sort(sortEventsByDate)
        }
        return {
          'events': events,
          'show_qr_code': showQRCode
        }
      } catch (error) {
        // console.warn(error)
        return false
      }
    // }
  } else {
    // console.warn('Insufficient api parameters')
    return false
  }
}

function formatDate (date) {
  return date.getFullYear() + '-' +
    String(parseInt(date.getMonth()) + 1).padStart(2, '0') +
    '-' + String(date.getDate()).padStart(2, '0')
}

function sortEventsByDate (a, b) {
  if (a.startDate < b.startDate) {
    return -1
  }

  if (a.startDate > b.startDate) {
    return 1
  }

  return 0
}
